module.exports = __webpack_public_path__ + "media/images/emblems/Grono_wappen-e94bcee6c82f233e59e939f3e3156739.svg";